import { useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { resetPasswordFetcher } from "../../api/requests";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useToaster } from "../../context/toaster";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";

function ForgetPassword() {
  const [signUpData, setSignUpData] = useState({});
  const [errors, setErrors] = useState({
    status: false,
    value: [],
  });
  const phoneRegex = /^09\d{9}$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const passRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&*]{8,}$/;
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const { addMessage } = useToaster();
  const logo2 = process.env.PUBLIC_URL + "/img/vaghfnama-logo.png";
  const [codeDigits, setCodeDigits] = useState(["", "", "", "", "", ""]);
  const [codeIsSent, setCodeIsSent] = useState(false);
  const [passType, setPassType] = useState("password");
  const [confirmPassType, setPassConfirmType] = useState("password");

  const showToast = (type, text) => {
    addMessage({
      id: Math.random().toString(36).substr(2, 9),
      type: type,
      text: text,
    });
  };

  const handleChange = (name, value) => {
    setSignUpData({ ...signUpData, [name]: value });
  };

  const handleResetPassword = async () => {
    setLoading(true);
    setErrors((prevErrors) => ({
      ...prevErrors,
      status: true,
      value: [],
    }));

    if (
      (phoneRegex.test(signUpData.username) ||
        emailRegex.test(signUpData.username)) &&
      passRegex.test(signUpData.new_password) &&
      signUpData.new_password === signUpData.confirm_password
    ) {
      try {
        const resetResponse = await resetPasswordFetcher.post(signUpData);

        if (resetResponse.message === "Password reset successfully.") {
          showToast("success", "تغییر رمز موفقیت‌آمیز بود.");

          setLoading(false);

          setErrors((prevErrors) => ({
            ...prevErrors,
            value: [],
          }));

          history.push("/auth/login");
        }
      } catch (error) {
        setLoading(false);
        setErrors((prevErrors) => ({
          ...prevErrors,
          status: true,
          value: Object.values(error.response?.data || ["خطایی رخ داده است"]),
        }));
      } finally {
        setLoading(false);
        setSignUpData({});
      }
    }
  };

  const handleDigitChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;

    const updatedDigits = [...codeDigits];
    updatedDigits[index] = value;
    setCodeDigits(updatedDigits);
    handleChange("code", updatedDigits.join(""));

    if (value && index < 5) {
      const nextInput = document.getElementById(`code-digit-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };

  const handleCodeFetching = () => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      status: true,
      value: [],
    }));

    if (
      phoneRegex.test(signUpData.username) ||
      emailRegex.test(signUpData.username)
    ) {
      setCodeIsSent(true);
    } else {
      !(
        phoneRegex.test(signUpData.username) ||
        emailRegex.test(signUpData.username)
      ) &&
        setErrors((prevErrors) => ({
          ...prevErrors,
          value: [
            ...prevErrors.value,
            "شماره موبایل و صحیح نمی باشد.",
          ],
        }));
    }
  };

  const handleEyeClick = () => {
    passType === "password" ? setPassType("text") : setPassType("password");
  };

  const handleEyeConfirmClick = () => {
    confirmPassType === "password"
      ? setPassConfirmType("text")
      : setPassConfirmType("password");
  };

  return (
    <>
      <Col md={5} className="p-5 bg-white full-height">
        <div className="login-main-left">
          <div className="text-center mb-5 login-main-left-header pt-4">
            <a href="/">
              <img src={logo2} width="40%" className="img-fluid" alt="LOGO" />
            </a>
          </div>

          {codeIsSent ? (
            <Form
              className="text-right"
              onSubmit={(e) => {
                e.preventDefault();
                handleResetPassword();
              }}
            >
              <Form.Group
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <Form.Label>کد</Form.Label>
                <div
                  className="d-flex"
                  style={{
                    direction: "ltr",
                    gap: "2%",
                    width: "100%",
                    justifyContent: "end",
                  }}
                >
                  {codeDigits.map((digit, index) => (
                    <Form.Control
                      key={index}
                      id={`code-digit-${index}`}
                      type="text"
                      maxLength={1}
                      value={digit}
                      onChange={(e) => handleDigitChange(e.target.value, index)}
                      style={{
                        width: "40px",
                        textAlign: "center",
                        fontSize: "18px",
                        padding: "6px",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        flexGrow: "1",
                      }}
                      onKeyDown={(e) => {
                        if (
                          e.key === "Backspace" &&
                          !codeDigits[index] &&
                          index > 0
                        ) {
                          const prevInput = document.getElementById(
                            `code-digit-${index - 1}`
                          );
                          if (prevInput) prevInput.focus();
                        }
                      }}
                    />
                  ))}
                </div>
              </Form.Group>

              <Form.Group>
                <Form.Label>رمز ورود جدید</Form.Label>
                <div style={{ position: "relative", width: "100%" }}>
                  <Form.Control
                    onChange={(e) =>
                      handleChange("new_password", e.target.value)
                    }
                    type={passType}
                    placeholder="رمز ورود باید حداقل 8 کرکتر از حروف و اعداد باشد"
                  />
                  <FontAwesomeIcon
                    width={12}
                    height={12}
                    icon={faEye}
                    style={{
                      position: "absolute",
                      top: "30%",
                      left: "3%",
                      cursor: "pointer",
                    }}
                    color="#deb887"
                    onClick={handleEyeClick}
                  />
                </div>
              </Form.Group>

              <Form.Group>
                <Form.Label>تکرار رمز ورود</Form.Label>
                <div style={{ position: "relative", width: "100%" }}>
                  <Form.Control
                    type={confirmPassType}
                    onChange={(e) =>
                      handleChange("confirm_password", e.target.value)
                    }
                    placeholder=""
                  />
                  <FontAwesomeIcon
                    width={12}
                    height={12}
                    icon={faEye}
                    style={{
                      position: "absolute",
                      top: "30%",
                      left: "3%",
                      cursor: "pointer",
                    }}
                    color="#deb887"
                    onClick={handleEyeConfirmClick}
                  />
                </div>
              </Form.Group>

              <div className="mt-4">
                <Row>
                  <Col>
                    <Button
                      type="submit"
                      variant="outline-primary"
                      size="lg"
                      block
                      style={{ cursor: loading ? "wait" : "pointer" }}
                    >
                      {loading ? "لطفا منتظر بمانید..." : "تغییر رمز ورود"}
                    </Button>
                    {errors.status &&
                      errors.value.map((item, index) => (
                        <p key={index} className="text-danger mt-1">
                          {item}
                        </p>
                      ))}
                  </Col>
                </Row>
              </div>
            </Form>
          ) : (
            <Form
              className="text-right"
              onSubmit={(e) => {
                e.preventDefault(); // Prevent default form submission
                handleCodeFetching(); // Handle sign-up logic
              }}
            >
              <Form.Group>
                <Form.Label>شماره موبایل خود را وارد کنید</Form.Label>
                <Form.Control
                  onChange={(e) => handleChange("username", e.target.value)}
                  type="text"
                  placeholder="شماره موبایل خود را وارد کنید..."
                />
              </Form.Group>

              <div className="mt-4">
                <Row>
                  <Col>
                    <Button
                      type="submit"
                      variant="outline-primary"
                      size="lg"
                      block
                      style={{ cursor: loading ? "wait" : "pointer" }}
                      onClick={async () => {
                        setLoading(true);
                        try {
                          const res = await resetPasswordFetcher.getCode({
                            username: signUpData.username,
                          });

                        } catch (err) {
                          console.error();
                        } finally {
                          setLoading(false);
                        }
                      }}
                    >
                      {loading ? "لطفا منتظر بمانید..." : "دریافت کد"}
                    </Button>
                    {errors.status &&
                      errors.value.map((item, index) => (
                        <p key={index} className="text-danger mt-1">
                          {item}
                        </p>
                      ))}
                  </Col>
                </Row>
              </div>
            </Form>
          )}

          <div className="text-center mt-3 ">
            <p className="light-gray mb-2">
              حساب کاربری دارید؟ <a href="/auth/login">ورود</a>
            </p>
            <p className="light-gray">
              حساب کاربری ندارید؟ <a href="/auth/register">ثبت نام</a>
            </p>
          </div>
        </div>
      </Col>
    </>
  );
}

export default ForgetPassword;
